import { MFANotSetupException, MFARequiredException } from '~/types/exceptions'

export default defineNuxtRouteMiddleware(async () => {
  const user = useUserStore()
  try {
    if (await user.isAuthenticated()) {
      return navigateTo('/portal')
    }
  } catch (error) {
    if (error instanceof MFARequiredException) {
      return navigateTo('/auth/totp/verify')
    }

    if (error instanceof MFANotSetupException) {
      return navigateTo('/auth/totp/setup')
    }

    throw error
  }
})
